<template>
  <div>
    <h1 class="text-xl font-medium leading-6 text-gray-900 mr-2">Let's get some background information about you</h1>
    <p class="mt-1 text-sm text-gray-500">
      We'll use this to personalize your experience within Humaniz and to provide you with timely alerts on your account
      where possible.
    </p>

    <div v-if="loaded" class="mt-6 mb-6 grid grid-cols-1 gap-x-4 gap-y-8 max-w-sm mx-auto">
      <TextInput
        label="First Name"
        placeholder="John"
        :model-value="form.firstName"
        @update:model-value="form.firstName = $event"
      />
      <TextInput
        label="Last Name"
        placeholder="Doe"
        :model-value="form.lastName"
        @update:model-value="form.lastName = $event"
      />
      <PhoneInput
        label="Mobile Phone Number"
        placeholder="+1 (281) 330 8004"
        :model-value="form.mobilePhoneNumber"
        @update:model-value="form.mobilePhoneNumber = $event"
      />
    </div>

    <div class="py-3 flex justify-center">
      <span class="flex w-full rounded-md shadow-sm sm:w-auto">
        <TButton color="amber" label="Continue" :disabled="!profileValidated" @click="nextStep" />
      </span>
    </div>
  </div>
</template>

<script>
import { useCurrentUserStore } from '@/stores/currentUser.ts';

export default {
  setup() {
    const currentUserStore = useCurrentUserStore();
    return { currentUserStore };
  },
  data() {
    return {
      loaded: false,
      profileCompleted: false,
      form: {
        firstName: '',
        lastName: '',
        mobilePhoneNumber: '',
      },
    };
  },
  computed: {
    user() {
      return this.currentUserStore.currentUser;
    },
    profileValidated() {
      return this.form.firstName !== '' && this.form.lastName !== '' && this.form.mobilePhoneNumber !== ''
        ? true
        : false;
    },
  },
  watch: {
    profileCompleted(newValue) {
      if (newValue) {
        this.$emit('go-forward');
      }
    },
  },
  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      await this.currentUserStore.loadCurrentUser();
      this.form = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        mobilePhoneNumber: this.user?.mobilePhoneNumber ?? '',
      };
      this.profileCompleted =
        this.form.firstName !== null &&
        this.form.firstName !== '' &&
        this.form.lastName !== null &&
        this.form.lastName !== '' &&
        this.form.mobilePhoneNumber !== null &&
        this.form.mobilePhoneNumber !== '';

      this.loaded = true;
    },
    async nextStep() {
      await this.currentUserStore.updateUser({
        user: this.user,
        updatedUserAttributes: {
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          mobile_phone_number: this.form.mobilePhoneNumber,
        },
      });
      this.$emit('go-forward');
    },
  },
};
</script>
